<script setup lang="ts"></script>

<template>
  <div
    class="h-full w-full flex flex-col items-center justify-center bg-background text-foreground px-4"
  >
    <div class="flex flex-col items-center gap-8 max-w-md text-center">
      <img
        class="h-32 w-auto object-contain"
        src="https://res.cloudinary.com/stuut/image/upload/v1761861310/logos/stuut-full.png"
      />

      <div class="flex flex-col gap-3">
        <h1 class="text-2xl font-semibold">We'll be right back.</h1>
        <p class="text-muted-foreground font-medium">
          Our platform is currently undergoing scheduled maintenance to improve your experience.
          We'll be back online shortly.
        </p>
      </div>

      <div class="flex flex-col gap-2">
        <p>
          If you have any urgent questions, <br />
          please contact our support team at
        </p>

        <a href="mailto:support@stuut.co" class="text-primary hover:underline font-medium">
          support@stuut.co
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
